import au from "./flag-au.png";
import be from "./flag-be.png";
import ca from "./flag-ca.png";
import ch from "./flag-ch.png";
import de from "./flag-de.png";
import fr from "./flag-fr.png";
import nl from "./flag-nl.png";
import nz from "./flag-nz.png";
import se from "./flag-se.png";
import uk from "./flag-uk.png";
import us from "./flag-us.png";
import an from "./flag-an.png";
import at from "./flag-at.png";
import bs from "./flag-bs.png";
import il from "./flag-il.png";
var flag = {
  au: au,
  be: be,
  ca: ca,
  ch: ch,
  de: de,
  fr: fr,
  nl: nl,
  nz: nz,
  se: se,
  uk: uk,
  us: us,
  an: an,
  at: at,
  bs: bs,
  il: il
};
export default flag;